export enum StatsFields {
    NUMBER_OF_STUDENTS = 'numberOfStudents',
    UNPROFITABLE_COURSES = 'unprofitableCourses',
    TEACHERS_WITHOUT_COURSES = 'teachersWithoutCourses',
    INSTITUTIONS_WITHOUT_COURSES = 'institutionsWithoutCourses',
    TEACHER_TERMINATION_STATS = 'teacherTerminationStats',
    INCOME = 'income',
    EMPLOYEE_ACQUISITION_STATS = 'employeeAcquisitionStats',
    SIGNUPS_PER_INSTITUTION = 'signupsPerInstitution',
}
